import React from "react";

import { Container, Row, Col } from "react-bootstrap";
import styles from "../assets/styles/module.styles";
import bg from "../assets/images/impressum-1.jpg";
import TeamJumbotron from "../components/team/TeamJumbotron";
import TeamMembers from "../components/team/TeamMembers";
import TeamContactForm from "../components/team/TeamContactForm";
import Footer from "../components/shared/footer";
import colors from "../assets/styles/colors";
import Jumbotron from "../components/jumpbotron";

const CONTACT = [
  {
    title: "maracuja.app wird betrieben von:",
    texts: [
      ["mara cuja UG (Haftungsbeschränkt)", "Grüner Weg 119", "58644 Iserlohn"],
      ["Telefon: +49(0)177 6748613", "E-Mail: hello@maracuja.app"],
    ],
  },
  {
    title: "Geschäftsführer:",
    texts: [
      ["Vadim Eberle"],
      [
        "Eintragung im Handelsregister beim",
        "Amtsgericht Iserlohn",
        "Registernummer: HRB 9405",
        "Steuernummer: 328/5830/1169",
      ],
      [
        "Das Impressum auf der Webseite www.maracuja.app ist ebenfalls gültig für die maracuja.app-Auftritte auf facebook, Instagram, twitter, Google und Pinterest.",
      ],
    ],
  },
];
const CONTENT = [
  {
    title: "Haftung für Inhalte",
    text: [
      "Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.",
    ],
  },
  {
    title: "Haftung für Links",
    text: [
      "Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.",
    ],
  },
  {
    title: "Urheberrecht",

    text: [
      "Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.",
    ],
  },
  {
    title: "Datenschutz",
    text: [
      "Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen für unseren Newsletter) erhoben werden, erfolgt dies stets auf freiwilliger Basis. Diese Daten werden ohne Ihre ausdrückliche Zustimmung nicht an Dritte weitergegeben. Wir verweisen ausdrücklich auf unsere Datenschutzerklärung unter (www.maracuja.app/datenschutz/).",

      "Der Nutzung von im Rahmen der Impressumspflicht veröffentlichten Kontaktdaten durch Dritte zur Übersendung von nicht ausdrücklich angeforderter Werbung und Informationsmaterialien wird hiermit ausdrücklich widersprochen.",
    ],
  },
];
const Legals = () => {
  return (
    <Container>
      <Row
        className="justify-content-center"
        style={{ paddingBottom: "6em", paddingTop: "5em" }}
      >
        <Col lg={{ span: 10 }} style={s.text}>
          <p style={s.title}>maracuja Impressum:</p>

          {CONTACT.map((c) => {
            return (
              <div>
                <p style={s.title}>{c.title}</p>
                {c.texts.map((ts) => {
                  return (
                    <div style={{ marginBottom: "1em" }}>
                      {ts.map((t) => {
                        return (
                          <span>
                            {t}
                            <br />
                          </span>
                        );
                      })}
                    </div>
                  );
                })}
              </div>
            );
          })}
          {CONTENT.map((c) => {
            return (
              <div>
                <p style={s.title}>{c.title}</p>
                {c.text.map((t) => {
                  return <p>{t}</p>;
                })}
              </div>
            );
          })}
        </Col>
      </Row>
    </Container>
  );
};

export default function ImpressumView() {
  return (
    <div style={{ flex: 1 }}>
      <Jumbotron height="80vh" image={bg} className="align-items-end">
        <Container>
          <Row className="justify-content-left">
            <Col className="offset-1">
              <span
                style={{
                  ...styles.montserratLight,
                  fontSize: "1.4em",
                  color: "white",
                }}
              >
                Impressum
              </span>
            </Col>
          </Row>
        </Container>
      </Jumbotron>

      {/* Membmers */}

      <Legals />
      {/* Footer */}
      <Footer color={colors.goldenYellow} />
    </div>
  );
}

const s = {
  title: {
    ...styles.montserratSemiBold,
    color: colors.goldenYellow,
    fontSize: "0.9em",
  },
  text: {
    ...styles.montserratRegular,
    color: colors.brownishGrey,
    fontSize: "0.9em",
    lineHeight: "1.7em",
  },
};
